// import "./new.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Select from "react-select";
// import Navbar from "../../components/navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { examinationInputs } from "../../formSource";
// import { useNavigate } from "react-router-dom";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// const PaperOptions = [
//   { value: "Monthly", label: "Monthly" },
//   { value: "Module-1", label: "Module-1" },
//   { value: "Module-2", label: "Module-2" },
//   { value: "Module-3", label: "Module-3" },
//   { value: "Mock", label: "Mock" },
//   { value: "Preliam", label: "Preliam" },
// ];

// const CheckingOptions = [
//   { value: "Done", label: "Done" },
//   { value: "Not Done", label: "Not Done" },
// ];
// const DurationOptions = [
//   { value: "3hr", label: "3hr" },
//   { value: "2hr", label: "2hr" },
//   { value: "1hr", label: "1hr" },
// ];

// const ExaminationNew = ({ title }) => {
//   const [file, setFile] = useState("");
//   const [inputValues, setInputValues] = useState({});
//   const [notification, setNotification] = useState("");
//   const [classoptions, setClassoptions] = useState([]);
//   const [subjectoptions, setSubjectoptions] = useState([]);
//   const [useroptions, setUseroptions] = useState([]);
//   const [isNotificationVisible, setIsNotificationVisible] = useState(false);
//   const center_id = localStorage.getItem("center_id");
//   let [token] = useState(localStorage.getItem("token"));
//   const navigate = useNavigate();
//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const handlePaperSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       type: selectedOption.value,
//     });
//   };

//   const handleCheckSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       checking_status: selectedOption.value,
//     });
//   };

//   const handleDurationSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       duration: selectedOption.value,
//     });
//   };

//   const handleClassSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       class_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     class_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const class_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setClassoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleSubjectSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       subject_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     subject_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const subject_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setSubjectoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleUserSelectChange = (selectedOption) => {
//     setInputValues({
//       ...inputValues,
//       user_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     user_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const user_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setUseroptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleInputChange = (e) => {
//     console.log(e.target.name);
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//     console.log("inputValues", inputValues);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("class_id", inputValues.class_id);
//     formData.append("subject_id", inputValues.subject_id);
//     formData.append("type", inputValues.type);
//     formData.append("month", inputValues.month);
//     formData.append("date", inputValues.date);
//     formData.append("total_marks", inputValues.total_marks);
//     formData.append("user_id", inputValues.user_id);
//     formData.append("schedule_start_time", inputValues.schedule_start_time);
//     formData.append("schedule_end_time", inputValues.schedule_end_time);

//     // Set defaults if empty
//     formData.append("start_time", inputValues.start_time || "00:00");
//     formData.append("end_time", inputValues.end_time || "00:00");
//     formData.append("duration", inputValues.duration);
//     formData.append(
//       "checking_status",
//       inputValues.checking_status || "Not Done"
//     );
//     formData.append("status", inputValues.status || 1);
//     formData.append("logo", file); // Append the file to FormData

//     try {
//       // Send formData to the server using an HTTP request with multipart/form-data
//       const response = await fetch(`${serverUrl}/add_examination`, {
//         method: "POST",
//         body: formData, // Use formData here with multipart/form-data
//       });

//       const data = await response.json();
//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });
//         } else {
//           toast.error(data.message || "Something went wrong.");
//         }

//         // Clear all input data and roles when error occurs
//         // setInputValues({});
//         // setSelectedUser([]);

//         // Force the component to rerender with the empty state
//         setTimeout(() => {}, 500); // Adding timeout to allow state change
//       } else {
//         toast.success("Examination added successfully!");

//         // Clear form data after success
//         setInputValues({});
//         // setSelectedUser([]);

//         // Navigate to the users page after success
//         setTimeout(() => {
//           navigate("/examinations");
//         }, 1000);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="left">
//                 {file && file.type && file.type === "application/pdf" ? (
//                   <img
//                     src="/images/pdf_icon.png"
//                     alt="Marksheet PDF"
//                     className="itemImg"
//                   />
//                 ) : file && file.type && file.type.startsWith("image/") ? (
//                   <img
//                     src={URL.createObjectURL(file)}
//                     alt="Marksheet Preview"
//                     className="itemImg"
//                   />
//                 ) : (
//                   <img
//                     src={file || "/images/upload_file.png"}
//                     alt="Default Marksheet"
//                     className="itemImg"
//                   />
//                 )}
//               </div>
//               <div className="right">
//                 <form onSubmit={handleSubmit}>
//                   <div className="formInput">
//                     <label htmlFor="file">
//                       Paper: <DriveFolderUploadOutlinedIcon className="icon" />
//                     </label>
//                     <input
//                       type="file"
//                       id="file"
//                       accept="image/*,.pdf"
//                       onChange={(e) => setFile(e.target.files[0])}
//                       style={{ display: "none" }}
//                     />
//                   </div>
//                   {examinationInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       {input.fieldName === "status" ||
//                       input.fieldName === "start_time" ||
//                       input.fieldName === "end_time" ||
//                       input.fieldName === "checking_status" ? null : (
//                         <>
//                           <label>{input.label}</label>
//                           {input.fieldName === "class_id" ? (
//                             <Select
//                               options={classoptions}
//                               name={input.fieldName}
//                               onChange={handleClassSelectChange}
//                               required
//                             />
//                           ) : input.fieldName === "subject_id" ? (
//                             <Select
//                               options={subjectoptions}
//                               name={input.fieldName}
//                               onChange={handleSubjectSelectChange}
//                               required
//                             />
//                           ) : input.fieldName === "user_id" ? (
//                             <Select
//                               options={useroptions}
//                               name={input.fieldName}
//                               onChange={handleUserSelectChange}
//                               required
//                             />
//                           ) : input.fieldName === "checking_status" ? (
//                             <Select
//                               options={CheckingOptions}
//                               name={input.fieldName}
//                               onChange={handleCheckSelectChange}
//                               required
//                             />
//                           ) : input.fieldName === "type" ? (
//                             <Select
//                               options={PaperOptions}
//                               name={input.fieldName}
//                               onChange={handlePaperSelectChange}
//                               required
//                             />
//                           ) : input.fieldName === "duration" ? (
//                             <Select
//                               options={DurationOptions}
//                               name={input.fieldName}
//                               onChange={handleDurationSelectChange}
//                               required
//                             />
//                           ) : (
//                             <input
//                               type={input.type}
//                               placeholder={input.placeholder}
//                               name={input.fieldName}
//                               onChange={handleInputChange}
//                               required={input.fieldName !== "status"}
//                             />
//                           )}
//                         </>
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formSubmit">
//                     <button type="submit" style={{ float: "right" }}>
//                       Send
//                     </button>
//                   </div>
//                 </form>
//                 {isNotificationVisible && (
//                   <div className="notification">{notification}</div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default ExaminationNew;

import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Select from "react-select";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const FilePreviewContainer = styled("div")({
  position: "relative",
  width: "100%",
  height: 200,
  borderRadius: 12,
  border: "2px dashed #e0e0e0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#fafafa",
  marginBottom: 20,
  overflow: "hidden",
  transition: "all 0.3s ease",
  "&.drag-active": {
    borderColor: "#7451f8",
    backgroundColor: "rgba(116, 81, 248, 0.05)",
  },
});

const PreviewImage = styled("img")({
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "contain",
});

const FileInfo = styled("div")({
  marginTop: 10,
  textAlign: "center",
  "& .fileName": {
    fontWeight: 500,
    color: "#333",
    fontSize: 14,
    marginTop: 8,
    wordBreak: "break-all",
    padding: "0 10px",
  },
  "& .fileSize": {
    color: "#757575",
    fontSize: 12,
  },
});

const RemoveButton = styled(Button)({
  position: "absolute",
  top: 8,
  right: 8,
  minWidth: 30,
  height: 30,
  borderRadius: "50%",
  padding: 0,
});

const StyledSelect = styled(Select)({
  width: "100%",
  "& .select__control": {
    minHeight: 46,
    border: "1px solid #e2e8f0",
    borderRadius: 6,
    backgroundColor: "#f8fafc",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "#cbd5e0",
    },
  },
  "& .select__control--is-focused": {
    borderColor: "#7451f8",
    boxShadow: "0 0 0 3px rgba(116, 81, 248, 0.15)",
    backgroundColor: "white",
  },
  "& .select__value-container": {
    padding: "2px 8px",
  },
  "& .select__indicator": {
    padding: "8px",
  },
});

const PaperOptions = [
  { value: "Monthly", label: "Monthly" },
  { value: "Module-1", label: "Module-1" },
  { value: "Module-2", label: "Module-2" },
  { value: "Module-3", label: "Module-3" },
  { value: "Mock", label: "Mock" },
  { value: "Preliam", label: "Preliam" },
];

const CheckingOptions = [
  { value: "Done", label: "Done" },
  { value: "Not Done", label: "Not Done" },
];
const DurationOptions = [
  { value: "3hr", label: "3hr" },
  { value: "2hr", label: "2hr" },
  { value: "1hr", label: "1hr" },
];

const ExaminationNew = ({ title }) => {
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState("");
  const [dragActive, setDragActive] = useState(false);
  const [inputValues, setInputValues] = useState({});
  const [classoptions, setClassoptions] = useState([]);
  const [subjectoptions, setSubjectoptions] = useState([]);
  const [useroptions, setUseroptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const center_id = localStorage.getItem("center_id");
  let [token] = useState(localStorage.getItem("token"));
  const navigate = useNavigate();

  const redirectToLogin = () => {
    toast.warning("Please login first to access this page", {
      autoClose: 2000,
      onClose: () => (window.location.href = "/"),
    });
  };

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const selectedFile = e.dataTransfer.files[0];
      processFile(selectedFile);
    }
  }, []);

  const processFile = (selectedFile) => {
    if (!selectedFile) return;

    // Validate file type
    const validTypes = ["image/jpeg", "image/png", "application/pdf"];
    if (!validTypes.includes(selectedFile.type)) {
      toast.error("Please upload an image (JPG/PNG) or PDF file");
      return;
    }

    // Validate file size (max 5MB for papers)
    if (selectedFile.size > 5 * 1024 * 1024) {
      toast.error("File size exceeds 5MB limit");
      return;
    }

    setFile(selectedFile);

    if (selectedFile.type === "application/pdf") {
      setFilePreview("/images/pdf_icon.png");
    } else {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFilePreview(e.target.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      processFile(e.target.files[0]);
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setFilePreview("");
  };

  const handlePaperSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      type: selectedOption.value,
    });
  };

  const handleCheckSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      checking_status: selectedOption.value,
    });
  };

  const handleDurationSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      duration: selectedOption.value,
    });
  };

  const handleClassSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      class_id: selectedOption.value,
    });
  };

  useEffect(() => {
    class_name();
    subject_name();
    user_name();
  }, []);

  const class_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/class_ids_dp/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch classes");
      const data = await response.json();

      const namelist = data.data.map((item) => ({
        value: item.class_id, // or group_id if you want to select by group
        label: item.group_name
          ? `${item.class_name} - ${item.group_name}`
          : item.class_name,
      }));

      setClassoptions(namelist);
    } catch (error) {
      console.error("Error fetching classes:", error);
      toast.error("Failed to load classes");
    }
  };
  const handleSubjectSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      subject_id: selectedOption.value,
    });
  };

  const subject_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/subject_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch subjects");
      const data = await response.json();
      const namelist = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setSubjectoptions(namelist);
    } catch (error) {
      console.error("Error fetching subjects:", error);
      toast.error("Failed to load subjects");
    }
  };

  const handleUserSelectChange = (selectedOption) => {
    setInputValues({
      ...inputValues,
      user_id: selectedOption.value,
    });
  };

  const user_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch users");
      const data = await response.json();
      const namelist = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setUseroptions(namelist);
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to load users");
    }
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error("Please upload the examination paper");
      return;
    }
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("center_id", center_id);
    formData.append("class_id", inputValues.class_id);
    formData.append("subject_id", inputValues.subject_id);
    formData.append("type", inputValues.type);
    formData.append("month", inputValues.month);
    formData.append("date", inputValues.date);
    formData.append("total_marks", inputValues.total_marks);
    formData.append("user_id", inputValues.user_id);
    formData.append("schedule_start_time", inputValues.schedule_start_time);
    formData.append("schedule_end_time", inputValues.schedule_end_time);
    formData.append("start_time", inputValues.start_time || "00:00");
    formData.append("end_time", inputValues.end_time || "00:00");
    formData.append("duration", inputValues.duration);
    formData.append(
      "checking_status",
      inputValues.checking_status || "Not Done",
    );
    formData.append("status", inputValues.status || 1);
    formData.append("logo", file);

    const toastId = toast.loading("Adding new examination...");

    try {
      const response = await fetch(`${serverUrl}/add_examination`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        toast.update(toastId, {
          render: data.message || "Failed to add examination",
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });

        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        }
      } else {
        toast.update(toastId, {
          render: "Examination added successfully!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });

        // Reset form
        setInputValues({});
        setFile(null);
        setFilePreview("");

        setTimeout(() => {
          navigate("/examinations");
        }, 1500);
      }
    } catch (error) {
      console.log(error);
      toast.update(toastId, {
        render: "Error occurred while adding examination",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    } finally {
      setIsSubmitting(false); // 🔹 Re-enable the button after response
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-right" autoClose={3000} />
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      <Grid item xs={12} className="formGridItem">
                        <FilePreviewContainer
                          className={dragActive ? "drag-active" : ""}
                          onDragEnter={handleDrag}
                          onDragOver={handleDrag}
                          onDragLeave={handleDrag}
                          onDrop={handleDrop}
                        >
                          {filePreview ? (
                            <>
                              <PreviewImage
                                src={filePreview}
                                alt="Examination Paper Preview"
                              />
                              {file && (
                                <>
                                  <FileInfo>
                                    <div className="fileName">{file.name}</div>
                                    <div className="fileSize">
                                      {(file.size / 1024).toFixed(1)} KB
                                    </div>
                                  </FileInfo>
                                  <RemoveButton
                                    variant="contained"
                                    color="error"
                                    onClick={handleRemoveFile}
                                  >
                                    ×
                                  </RemoveButton>
                                </>
                              )}
                            </>
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                p: 2,
                              }}
                            >
                              <CloudUploadIcon
                                sx={{
                                  fontSize: 48,
                                  color: dragActive ? "#7451f8" : "#bdbdbd",
                                  mb: 1,
                                  transition: "color 0.3s",
                                }}
                              />
                              <Typography variant="body1" color="textSecondary">
                                {dragActive
                                  ? "Drop your paper here"
                                  : "Drag & drop your paper here or"}
                              </Typography>
                              <Button
                                component="label"
                                variant="outlined"
                                startIcon={<DriveFolderUploadOutlinedIcon />}
                                sx={{ mt: 2 }}
                              >
                                Browse Files
                                <VisuallyHiddenInput
                                  type="file"
                                  accept="image/*,.pdf"
                                  onChange={handleFileChange}
                                  required
                                />
                              </Button>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                sx={{ mt: 1 }}
                              >
                                (Supports JPG, PNG, PDF up to 5MB)
                              </Typography>
                            </Box>
                          )}
                        </FilePreviewContainer>
                      </Grid>

                      {/* Class Selection */}
                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Class</label>
                          <StyledSelect
                            options={classoptions}
                            name="class_id"
                            onChange={handleClassSelectChange}
                            required
                            classNamePrefix="select"
                          />
                        </div>
                      </Grid>

                      {/* Subject Selection */}
                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Subject</label>
                          <StyledSelect
                            options={subjectoptions}
                            name="subject_id"
                            onChange={handleSubjectSelectChange}
                            required
                            classNamePrefix="select"
                          />
                        </div>
                      </Grid>

                      {/* Paper Type */}
                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Paper Type</label>
                          <StyledSelect
                            options={PaperOptions}
                            name="type"
                            onChange={handlePaperSelectChange}
                            required
                            classNamePrefix="select"
                          />
                        </div>
                      </Grid>

                      {/* User Selection */}
                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Invigilator</label>
                          <StyledSelect
                            options={useroptions}
                            name="user_id"
                            onChange={handleUserSelectChange}
                            required
                            classNamePrefix="select"
                          />
                        </div>
                      </Grid>

                      {/* Duration */}
                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Duration</label>
                          <StyledSelect
                            options={DurationOptions}
                            name="duration"
                            onChange={handleDurationSelectChange}
                            required
                            classNamePrefix="select"
                          />
                        </div>
                      </Grid>

                      {/* Checking Status */}
                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Checking Status</label>
                          <StyledSelect
                            options={CheckingOptions}
                            name="checking_status"
                            onChange={handleCheckSelectChange}
                            required
                            classNamePrefix="select"
                          />
                        </div>
                      </Grid>

                      {/* Date Fields */}
                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Month</label>
                          <input
                            type="month"
                            placeholder="Select month"
                            name="month"
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Date</label>
                          <input
                            type="date"
                            placeholder="Select date"
                            name="date"
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </Grid>

                      {/* Time Fields */}
                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Start Time</label>
                          <input
                            type="time"
                            placeholder="Start time"
                            name="schedule_start_time"
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>End Time</label>
                          <input
                            type="time"
                            placeholder="End time"
                            name="schedule_end_time"
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </Grid>

                      {/* Marks */}
                      <Grid item xs={12} sm={6} className="formGridItem">
                        <div className="formInput">
                          <label>Total Marks</label>
                          <input
                            type="number"
                            placeholder="Enter total marks"
                            name="total_marks"
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </Grid>
                    </Grid>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/examinations")}
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                        disabled={isSubmitting} // 🔹 disable while submitting
                      >
                        {isSubmitting ? "Creating..." : "Create Examination"}
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
    </ThemeProvider>
  );
};

export default ExaminationNew;
